//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TRUSTPILOT_URL } from '~/const/3rd';
export default {
  name: 'TrustPilot',

  mounted() {
    this.asyncScript(TRUSTPILOT_URL).then(() => {}).catch(err => {
      console.error('TRUSTPILOT_URL FAILED', err);
    });
  }

};